const toAction = (type = 'NO TYPE PROVIDED', payload: any = 'NO PAYLOAD PROVIDED') =>
  ({ type, payload });

export default toAction;
